/**
 * clubs feature routes. Clubs were merged into 나의 대회 (CLAUDE.md §15 #412): the club pages are
 * gone; what stays here is the self-entry scorer page (used by personal tournaments with
 * allowSelfEntry) and the /join/:token page, which now joins a personal member list.
 * The pathless "clubsFeature" route is registered once in src/app/router.tsx (frozen).
 */
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rootRoute } from '../../app/root-route';
import { installSelfEntryGuard } from './lib/self-entry-session';

// revoke a SELF_ENTRY session as soon as the USER session that requested it ends
installSelfEntryGuard();

export const clubsFeature = createRoute({ getParentRoute: () => rootRoute, id: 'clubs' });

/** invite link to a personal member list ("내 멤버") */
export const joinRoute = createRoute({
  getParentRoute: () => clubsFeature,
  path: '/join/$inviteToken',
  component: lazyRouteComponent(() => import('./pages/JoinPage'), 'JoinPage'),
});

/** self entry (SELF_ENTRY PLAYER session, CLAUDE.md §15 #55) */
export const selfEntryRoute = createRoute({
  getParentRoute: () => clubsFeature,
  path: '/me/tournaments/$tournamentId/score',
  component: lazyRouteComponent(() => import('./pages/SelfEntryPage'), 'SelfEntryPage'),
});

export const clubsRouteTree = clubsFeature.addChildren([selfEntryRoute, joinRoute]);
